import { IEntityMinimalModel, IModifiedRecordParameters } from "../../../../api/GenericTypes";
import { toValidDate } from "../../../datetime/DateTimeFormatter";

export interface IModificationRecordEntityForm {
  modifiedByIds?: IEntityMinimalModel[] | undefined | null;
  modifiedFrom?: Date | undefined | null;
  modifiedTo?: Date | undefined | null;
}

export const ModificationRecordEntityDefaultFilterFormValues: Required<IModificationRecordEntityForm> = {
  modifiedByIds: null,
  modifiedFrom: null,
  modifiedTo: null,
};

export const modificationRecordEntityFormToFilters = <Filters extends Partial<IModifiedRecordParameters>>(
  form: IModificationRecordEntityForm
): Filters => {
  let filters = {} as Filters;
  filters.modifiedByIds =
    Array.isArray(form.modifiedByIds) && form.modifiedByIds.length > 0 ? form.modifiedByIds?.map((d) => d.id) : null;
  filters.modifiedFrom = toValidDate(form.modifiedFrom);
  filters.modifiedTo = toValidDate(form.modifiedTo);
  return filters;
};

export const modificationRecordEntityFiltersToForm = (
  filters: Partial<IModifiedRecordParameters>
): IModificationRecordEntityForm => {
  return {
    modifiedByIds: filters.modifiedByIds ? filters.modifiedByIds.map((id) => ({ id, name: "" })) : null,
    modifiedFrom: filters.modifiedFrom ? new Date(filters.modifiedFrom) : null,
    modifiedTo: filters.modifiedTo ? new Date(filters.modifiedTo) : null,
  };
};
